import moment from 'moment';

export default class MomentService {
    /* @ngInject */
    constructor() {
        this.moment = moment;
        this.moment.locale('en');
    }

    startOfWeek(date = new Date()) {
        return this.moment(date).startOf('week').toDate();
    }

    endOfDay(date = new Date()) { // eslint-disable-line class-methods-use-this
        date.setHours(23, 59, 59);
        return date;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/moment.service.js